import * as serviceContext from './serviceContext';
import { REPORTS_ROOT as ReportsURL } from '../configs/api';

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;

export async function getNotification(data) {
    try {
        const response = await serviceContext.get(ReportsURL + "v2/api/manage/notification?" + data, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};